import { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { setProductFeaturePage } from '../redux/reducer/website.reducer';
import { getRequest } from 'src/services';
import { endpoints } from 'src/utils/axios';

const useProductFeatureSection = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();

  const getProductFeatureSectionJson = useCallback(async (page = 1) => {
    setLoading(true);
    setError(null);

    try {
      const response = await getRequest(`${endpoints.admin_dashboard.website.product_feature_page.product_feature_section}`);
      console.log("🚀 ~ getProductFeatureSectionJson ~ data:", response);
      console.log("🚀 ~ getProductFeatureSectionJson ~ data.data:", JSON.parse(response.web_page.json_data));

      const finalResponse = JSON.parse(response.web_page.json_data);

      if (finalResponse) {
        dispatch(setProductFeaturePage(finalResponse));
        setData(finalResponse);
      }

      return finalResponse;
    } catch (err) {
      console.error("Error fetching Product Feature section data:", err);
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  }, [dispatch]);

  // Optional: Auto-fetch on mount
  const fetchOnMount = useCallback(() => {
    getProductFeatureSectionJson();
  }, [getProductFeatureSectionJson]);

  return {
    data,
    loading,
    error,
    getProductFeatureSectionJson,
    fetchOnMount,
    refetch: getProductFeatureSectionJson
  };
};

export default useProductFeatureSection;
